import React from 'react'

function EditPayment() {
  return (
    <div>EditPayment</div>
  )
}

export default EditPayment